<template>
  <div>
    <template v-for="item in items">
      <el-submenu
        v-if="hasChildren(item)"
        :key="`sub-${item.id || item.path || item.name}`"
        :index="normalizePath(item)"
      >
        <template slot="title">
          <span>{{ item.name }}</span>
        </template>
        <sidebar-menu :items="item.children" />
      </el-submenu>
      <el-menu-item
        v-else
        :key="`item-${item.id || item.path || item.name}`"
        :index="normalizePath(item)"
      >
        {{ item.name }}
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarMenu",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    hasChildren(item) {
      return Array.isArray(item.children) && item.children.length > 0;
    },
    normalizePath(item) {
      if (item && item.routePath) {
        return item.routePath;
      }
      if (item && item.path) {
        return item.path.startsWith("/") ? item.path : `/${item.path}`;
      }
      return `/menus?id=${(item && item.id) || ""}`;
    }
  }
};
</script>
